import { Box } from '@medly-components/core';
import { MobileNavHeaderMinHeight } from 'components/common/Styled';
import styled from 'styled-components';

export const MapPageWrapper = styled(Box)`
    grid-area: main;
    padding: 0;
    overflow-y: auto;
    position: relative;
    background: ${({ theme }) => theme.colors.grey[50]};
    width: 100%;
    border-radius: 0;
    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        margin: 0;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        min-height: calc(100% - ${MobileNavHeaderMinHeight});
    }
`;
